.Stack {
    display: flex;
    flex-direction: column;
}

.isRow {
    flex-direction: row;
}

.isRowReverse {
    flex-direction: row-reverse;
}

.isColumnReverse {
    flex-direction: column-reverse;
}

/* Alignment */
.alignItemsCenter {
    align-items: center;
}

.alignItemsFlexStart {
    align-items: flex-start;
}

.alignItemsFlexEnd {
    align-items: flex-end;
}

.alignItemsStretch {
    align-items: stretch;
}

.alignItemsBaseline {
    align-items: baseline;
}

/* Justify Content */
.justifyContentCenter {
    justify-content: center;
}

.justifyContentFlexStart {
    justify-content: flex-start;
}

.justifyContentFlexEnd {
    justify-content: flex-end;
}

.justifyContentSpaceBetween {
    justify-content: space-between;
}

.justifyContentSpaceAround {
    justify-content: space-around;
}

.justifyContentSpaceEvenly {
    justify-content: space-evenly;
}

/* Flex Wrap */
.isWrap {
    flex-wrap: wrap;
}

.isWrapReverse {
    flex-wrap: wrap-reverse;
}
